import type { cmcIntervalType, cmcPeriodType } from 'components/Chart/chartUtils/chartSettings';

export const getCoinmarketcapChartPreviewBackup = async (
	id: number,
	timePeriod: cmcPeriodType,
	interval: cmcIntervalType,
	time_start: number,
	time_end: number,
	convertTo: string,
) => {
	const quoteCurrencyList = {
		eur: 2790,
		eth: 1027,
		btc: 1,
		usd: 2781,
	};
	try {
		const res = await fetch(
			`/api/coin-data/chart-preview/cmc-backup?id=${id}&time_period=${timePeriod}&interval=${interval}&time_start=${time_start}&time_end=${time_end}&convert_id=${quoteCurrencyList[convertTo]}`,
		);
		const data = await res.json();

		return data;
	} catch (error) {
		console.error(error);
	}
};
